module.exports = __webpack_public_path__ + "img/reload-icon.0fedb738.svg";